/**
 * Represents the status of an [[OrderPayment]].
 */
export var OrderPaymentStatus;
(function (OrderPaymentStatus) {
    /**
     * Payment has been recorded against the order for automatic-processing as part of [[OrderCompletion]].
     */
    OrderPaymentStatus["NotStarted"] = "NotStarted";
    /**
     * Payment has been started but final status unknown or incomplete.
     */
    OrderPaymentStatus["Pending"] = "Pending";
    /**
     * Payment was declined by the payment provider, e.g. invalid card number.
     */
    OrderPaymentStatus["Declined"] = "Declined";
    /**
     * Payment was completed successfully.
     */
    OrderPaymentStatus["Completed"] = "Completed";
})(OrderPaymentStatus || (OrderPaymentStatus = {}));
//# sourceMappingURL=order-payment-status.js.map